// Global
export const LOADING = "LOADING";
export const END_LOADING = "END_LOADING";
export const LOGIN = "LOGIN";
export const ALERT = "ALERT";
export const LOOKUP_TEXT = "LOOKUP_TEXT";
export const STRIPE_CUSTOMER = "STRIPE_CUSTOMER";
export const STRIPE_SUBSCRIPTION_PREVIEW = "STRIPE_SUBSCRIPTION_PREVIEW";
export const STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING = "STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING";
export const STRIPE_SUBSCRIPTION_EXTENDED = "STRIPE_SUBSCRIPTION_EXTENDED";
export const STRIPE_INVOICE = "STRIPE_INVOICE";
export const SEARCH = "SEARCH";
export const CHANGE_TAB = "CHANGE_TAB";
export const POST_CREATE_TEAM = "POST_CREATE_TEAM";
export const MARK_INVOICE_SENT = "MARK_INVOICE_SENT";
export const DEMO_FLOW_DONE = "DEMO_FLOW_DONE";
export const GET_MEMBER = "GET_MEMBER";
export const UPDATE_MEMBER = "UPDATE_MEMBER";
export const GET_TEAM = "GET_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const STRIPE_PRICE_CONFIG = "STRIPE_PRICE_CONFIG";
export const POST_UPGRADE_TEAM = "POST_UPGRADE_TEAM";
export const POST_SET_EMAIL_STEP = "POST_SET_EMAIL_STEP";
export const SET_ENV = "SET_ENV";
export const STRIPE_CUTOMER_PAYMENT_METHODS = "STRIPE_CUTOMER_PAYMENT_METHODS";
export const GET_HR_CONNECTIONS = "GET_HR_CONNECTIONS";
export const GET_AD_GROUPS = "GET_AD_GROUPS";
export const GET_AD_GROUP_USERS = "GET_AD_GROUP_USERS";
export const UPDATE_HR_CONNECTION_SYNC_CONF = "UPDATE_HR_CONNECTION_SYNC_CONF";
export const GET_MS_AD_MAPPING_CONF = "GET_MS_AD_MAPPING_CONF";
export const POST_CREATE_DEMO_TEAM = "POST_CREATE_DEMO_TEAM";
export const PATCH_UPDATE_DEMO_TEAM = "PATCH_UPDATE_DEMO_TEAM";
export const GET_DEMO_TEAMS = "GET_DEMO_TEAMS";
export const GET_INTEGRATION_CONNECTIONS = "GET_INTEGRATION_CONNECTIONS";
export const UPDATE_MEMBERS_TEAMS = "UPDATE_MEMBERS_TEAMS";
export const GET_LINKS_DATA = "GET_LINKS_DATA";
export const GET_DEVICES_FOR_MEMBER = "GET_DEVICES_FOR_MEMBER";
export const GET_TEAM_SALESFORCE_DATA = "GET_TEAM_SALESFORCE_DATA";
export const GET_MEMBER_CRM_EXPORT_LOGS = "GET_MEMBER_CRM_EXPORT_LOGS";
export const GET_TEAM_CRM_EXPORT_LOGS = "GET_TEAM_CRM_EXPORT_LOGS";
